// extracted by mini-css-extract-plugin
export default {"success-card":"integrationSettings_success-card__jEBVe","error-card":"integrationSettings_error-card__PvUm2","loading-plans":"integrationSettings_loading-plans__HVZyb"};